import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormDialogContainer } from '../FormDialog'
import ShareBoard from './ShareBoard'
import { submitShareCta, VIEWER_ROLE } from 'LiveBoard/modules/cta'
import { CTA_FORM_NAMES } from '../constants'
import countBy from 'lodash/countBy'
import get from 'lodash/get'

const ShareBoardContainer = ({
  config,
  lead,
  submitShareCta,
  onDone,
  area,
  initialValues
}) => {
  const handleEmailShare = (values) => {
    return submitShareCta({
      ...values,
      invitation_id: get(config, ['send_mail', 'invitation_id']),
      inviter_id: get(config, ['send_mail', 'sender', 'user_id'])
    })
  }

  return (
    <FormDialogContainer
      area={area}
      form={CTA_FORM_NAMES.share}
      config={config}
      onSubmit={handleEmailShare}
      onDone={onDone}
      initialValues={initialValues} >
      <ShareBoard lead={lead} />
    </FormDialogContainer>
  )
}

ShareBoardContainer.propTypes = {
  lead: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
  config: PropTypes.object.isRequired,
  submitShareCta: PropTypes.func.isRequired,
  area: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired
}

function mapStateToProps({ lead }) {
  return {
    lead,
    initialValues: {
      email: lead.email,
      name: lead.name,
      last_name: lead.last_name
    }
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ submitShareCta }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareBoardContainer)
